var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { PopoverPrivate } from '@snack-uikit/popover-private';
import styles from './styles.module.css';
export function Dropdown(_a) {
    var { content, trigger = 'click', placement = 'bottom-start', children, triggerRef, widthStrategy = 'gte', triggerClassName } = _a, otherProps = __rest(_a, ["content", "trigger", "placement", "children", "triggerRef", "widthStrategy", "triggerClassName"]);
    if (!children && !triggerRef) {
        return null;
    }
    return (_jsx(PopoverPrivate, Object.assign({ placement: placement, popoverContent: _jsx("div", { className: styles.dropdownContainer, children: content }), trigger: trigger, triggerRef: triggerRef, hasArrow: false, widthStrategy: widthStrategy, triggerClassName: cn(styles.defaultTriggerClassName, triggerClassName) }, otherProps, { children: children })));
}
